var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-nav-tabs',{attrs:{"options":_vm.options},on:{"tab-click":_vm.handleTabClick}})}
var staticRenderFns = []

export { render, staticRenderFns }